import React, { useState } from "react";
import UnloadingTables from "./UnloadingTables";
import axios from "axios";
import { getCurrentDate } from "../../Utilitie";
const CASUnloadingMaster = () => {
  const [unloadingData, setUnloadingData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [date, setDate] = useState(getCurrentDate());
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const fetchData = async () => {
    setError(null);
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}pendingUnloading?only_date=${date}`,
      );
      setError(null);
      setLoading(false);
    } catch {
      setError(null);
      setLoading(false);
    } finally {
      setError(null);
      setLoading(false);
    }
  };
  return (
    <div>
      <div className="row bg-dark text-white">
        <h5></h5>
      </div>
      Unloading Reports
      <UnloadingTables />
    </div>
  );
};
export default CASUnloadingMaster;
